webpackJsonp([1],{

/***/ "/i+J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e898872","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('nav',{staticClass:"navbar"},[_c('div',{staticClass:"navbar-brand"},[_c('router-link',{staticClass:"navbar-item",attrs:{"to":"/"}},[_vm._v("\n        ContactsApp\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"navbar-end"},[_c('router-link',{staticClass:"navbar-item",attrs:{"to":"/add"}},[_vm._v("Add New Contact")])],1)])]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("oM6K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/firebase/index.js
var firebase = __webpack_require__("Sazm");
var firebase_default = /*#__PURE__*/__webpack_require__.n(firebase);

// EXTERNAL MODULE: ./node_modules/firebase/firestore/index.js
var firestore = __webpack_require__("3VHS");
var firestore_default = /*#__PURE__*/__webpack_require__.n(firestore);

// CONCATENATED MODULE: ./src/components/firebaseConfig.js
/* harmony default export */ var firebaseConfig = ({
  apiKey: 'AIzaSyDr0-Mef6D1RZsD2NoBaPOwordhUW58MyU',
  authDomain: 'contacts-app-dca62.firebaseapp.com',
  databaseURL: 'https://contacts-app-dca62.firebaseio.com',
  projectId: 'contacts-app-dca62',
  storageBucket: 'contacts-app-dca62.appspot.com',
  messagingSenderId: '715354469790'
});
// CONCATENATED MODULE: ./src/components/firebaseInit.js




var firebaseApp = firebase_default.a.initializeApp(firebaseConfig);

/* harmony default export */ var firebaseInit = (firebaseApp.firestore());
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Home = ({
  name: 'home',
  data: function data() {
    return {
      contacts: [],
      loading: true
    };
  },
  created: function created() {
    var _this = this;

    firebaseInit.collection('contacts').get().then(function (querySnapshot) {
      _this.loading = false;
      querySnapshot.forEach(function (doc) {
        var data = {
          'id': doc.id,
          'firstname': doc.data().firstname,
          'lastname': doc.data().lastname,
          'emailaddress': doc.data().emailaddress,
          'phonenumber': doc.data().phonenumber,
          'slug': doc.data().slug
        };
        _this.contacts.push(data);
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebe3101c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-8"},[_c('h1',[_vm._v("All Contacts")]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loader-section"},[_c('div',{staticClass:"user-list"},[_c('div',{staticClass:"columns"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column is-4 right"},[_c('router-link',{staticClass:"button is-primary",attrs:{"to":"/user"}},[_vm._v("View Person")])],1)])]),_vm._v(" "),_c('div',{staticClass:"user-list"},[_c('div',{staticClass:"columns"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column is-4 right"},[_c('router-link',{staticClass:"button is-primary",attrs:{"to":"/user"}},[_vm._v("View Person")])],1)])]),_vm._v(" "),_c('div',{staticClass:"user-list"},[_c('div',{staticClass:"columns"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column is-4 right"},[_c('router-link',{staticClass:"button is-primary",attrs:{"to":"/user"}},[_vm._v("View Person")])],1)])]),_vm._v(" "),_c('div',{staticClass:"user-list"},[_c('div',{staticClass:"columns"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"column is-4 right"},[_c('router-link',{staticClass:"button is-primary",attrs:{"to":"/user"}},[_vm._v("View Person")])],1)])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.contacts),function(person){return _c('div',{staticClass:"user-list"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-8"},[_c('p',{staticClass:"user-list__header"},[_vm._v(_vm._s(person.firstname)+" "+_vm._s(person.lastname))]),_vm._v(" "),_c('div',{staticClass:"inner"},[_c('div',{staticClass:"left"},[_c('p',{staticClass:"user-list__sub"},[_c('strong',[_vm._v("Email")]),_vm._v(": "+_vm._s(person.emailaddress))])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('p',{staticClass:"user-list__sub"},[_c('strong',[_vm._v("Phone Number")]),_vm._v(": "+_vm._s(person.phonenumber))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-4 right"},[_c('router-link',{staticClass:"button is-primary",attrs:{"to":{ name: 'view-contact', params: { person: person.slug }}}},[_vm._v("View Person")])],1)])])})],2)])])}
var Home_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-8"},[_c('p',{staticClass:"user-list__header animated-background__header"}),_vm._v(" "),_c('p',{staticClass:"user-list__sub animated-background__sub"}),_vm._v(" "),_c('p',{staticClass:"user-list__sub animated-background__sub"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-8"},[_c('p',{staticClass:"user-list__header animated-background__header"}),_vm._v(" "),_c('p',{staticClass:"user-list__sub animated-background__sub"}),_vm._v(" "),_c('p',{staticClass:"user-list__sub animated-background__sub"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-8"},[_c('p',{staticClass:"user-list__header animated-background__header"}),_vm._v(" "),_c('p',{staticClass:"user-list__sub animated-background__sub"}),_vm._v(" "),_c('p',{staticClass:"user-list__sub animated-background__sub"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-8"},[_c('p',{staticClass:"user-list__header animated-background__header"}),_vm._v(" "),_c('p',{staticClass:"user-list__sub animated-background__sub"}),_vm._v(" "),_c('p',{staticClass:"user-list__sub animated-background__sub"})])}]
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var components_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("kFsq")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = "data-v-ebe3101c"
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  components_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_components_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ViewContact.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ViewContact = ({
  name: 'view-contact',
  data: function data() {
    return {
      firstname: null,
      lastname: null,
      emailaddress: null,
      phonenumber: null,
      success: this.$route.params.success
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    firebaseInit.collection('contacts').where('slug', '==', to.params.person).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        next(function (vm) {
          vm.firstname = doc.data().firstname;
          vm.lastname = doc.data().lastname;
          vm.emailaddress = doc.data().emailaddress;
          vm.phonenumber = doc.data().phonenumber;
        });
      });
    });
  },

  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      firebaseInit.collection('contacts').where('slug', '==', this.$route.params.person).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          console.log(doc.id, ' => ', doc.data());
          _this.firstname = doc.data().firstname;
          _this.lastname = doc.data().lastname;
          _this.emailaddress = doc.data().emailaddress;
          _this.phonenumber = doc.data().phonenumber;
          _this.success = _this.$route.params.success;
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-662f3aa2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewContact.vue
var ViewContact_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('h1',[_vm._v("View Contact")]),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"notification is-success"},[_vm._v("Contact successfully saved!")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contact--section"},[_c('p',{staticClass:"__name"},[_vm._v(_vm._s(_vm.firstname)+" "+_vm._s(_vm.lastname))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.emailaddress))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.phonenumber))])])])}
var ViewContact_staticRenderFns = []
var ViewContact_esExports = { render: ViewContact_render, staticRenderFns: ViewContact_staticRenderFns }
/* harmony default export */ var components_ViewContact = (ViewContact_esExports);
// CONCATENATED MODULE: ./src/components/ViewContact.vue
function ViewContact_injectStyle (ssrContext) {
  __webpack_require__("/i+J")
}
var ViewContact_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ViewContact___vue_template_functional__ = false
/* styles */
var ViewContact___vue_styles__ = ViewContact_injectStyle
/* scopeId */
var ViewContact___vue_scopeId__ = "data-v-662f3aa2"
/* moduleIdentifier (server only) */
var ViewContact___vue_module_identifier__ = null
var ViewContact_Component = ViewContact_normalizeComponent(
  ViewContact,
  components_ViewContact,
  ViewContact___vue_template_functional__,
  ViewContact___vue_styles__,
  ViewContact___vue_scopeId__,
  ViewContact___vue_module_identifier__
)

/* harmony default export */ var src_components_ViewContact = (ViewContact_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NewContact.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var NewContact = ({
  name: 'new-contact',
  data: function data() {
    return {
      firstname: null,
      lastname: null,
      emailaddress: null,
      phonenumber: null
    };
  },

  methods: {
    saveContact: function saveContact() {
      var _this = this;

      var slug = this.generateUUID();

      firebaseInit.collection('contacts').add({
        firstname: this.firstname,
        lastname: this.lastname,
        emailaddress: this.emailaddress,
        phonenumber: this.phonenumber,
        slug: slug
      }).then(function (docRef) {
        console.log('Document written with ID: ', docRef.id);
        _this.$router.push('/' + slug + '/success');
      }).catch(function (error) {
        console.error('Error adding document: ', error);
      });
    },
    generateUUID: function generateUUID() {
      var d = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
      });
      return uuid;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c07bb1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewContact.vue
var NewContact_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('h1',[_vm._v("Add New Contact")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveContact($event)}}},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("First Name")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstname),expression:"firstname"}],staticClass:"input",attrs:{"type":"text","placeholder":"First Name","required":""},domProps:{"value":(_vm.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstname=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Last Name")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastname),expression:"lastname"}],staticClass:"input",attrs:{"type":"text","placeholder":"Last Name","required":""},domProps:{"value":(_vm.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastname=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Email Address")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailaddress),expression:"emailaddress"}],staticClass:"input",attrs:{"type":"email","placeholder":"Email Address","required":""},domProps:{"value":(_vm.emailaddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailaddress=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Phone Number")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phonenumber),expression:"phonenumber"}],staticClass:"input",attrs:{"type":"text","placeholder":"Phone Number","required":""},domProps:{"value":(_vm.phonenumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phonenumber=$event.target.value}}})])]),_vm._v(" "),_vm._m(0)])])}
var NewContact_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-link",attrs:{"type":"submit"}},[_vm._v("Submit")])])])}]
var NewContact_esExports = { render: NewContact_render, staticRenderFns: NewContact_staticRenderFns }
/* harmony default export */ var components_NewContact = (NewContact_esExports);
// CONCATENATED MODULE: ./src/components/NewContact.vue
function NewContact_injectStyle (ssrContext) {
  __webpack_require__("jFOK")
}
var NewContact_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NewContact___vue_template_functional__ = false
/* styles */
var NewContact___vue_styles__ = NewContact_injectStyle
/* scopeId */
var NewContact___vue_scopeId__ = "data-v-54c07bb1"
/* moduleIdentifier (server only) */
var NewContact___vue_module_identifier__ = null
var NewContact_Component = NewContact_normalizeComponent(
  NewContact,
  components_NewContact,
  NewContact___vue_template_functional__,
  NewContact___vue_styles__,
  NewContact___vue_scopeId__,
  NewContact___vue_module_identifier__
)

/* harmony default export */ var src_components_NewContact = (NewContact_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js






vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_Home
  }, {
    path: '/add',
    name: 'new-contact',
    component: src_components_NewContact
  }, {
    path: '/:person/:success?',
    name: 'view-contact',
    component: src_components_ViewContact
  }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "jFOK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kFsq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oM6K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5e386c9000353e04d9a1.js